



















import Vue from 'vue'

import Artifacts from '@/components/artifacts/Artifacts.tsx'
import Editor from '@/components/artifacts/NewEditor.tsx'

export default Vue.extend({
  components: { Artifacts, Editor },
  props: {
    from: {
      type: String,
      required: true,
    },
    timeOfMeasurement: {
      type: String,
      required: true,
    },
    defaults: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  methods: {
    stamp(object: any) {
      object.time_of_measurement = this.timeOfMeasurement
      object.submitter_id = this.$store.getters.currentUserId
      object.case_id = this.$store.getters.currentCaseId
      return object
    },
  },
})
